export default "__VITE_ASSET__DPHj0Rdt__"